import script from "./AddFolderModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddFolderModal.vue?vue&type=script&setup=true&lang=js"

import "../../../../node_modules/@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css&external"
import "./AddFolderModal.vue?vue&type=style&index=1&id=67becda5&lang=scss"

const __exports__ = script;

export default __exports__